import {SubscriptionSource, SubscriptionTier, UserTier} from './subscriptionFeatures'

export const DEVICES_PER_SUBSCRIPTION = 10
export const ACTIVE_DEVICE_RANGE_IN_MONTHS = 3

export interface BaseSubscriptionInfo {
  isClassicUser: boolean
  subscriptionTier?: UserTier
  subscriptionSource?: SubscriptionSource
  trialLengthInDays?: number // Only for Trials
  trialExpirationDate?: Date // Only for Trials
  subscriptionRenewalDate?: Date // Only for Stripe Subs
  subscriptionExpirationDate?: Date
}

export function getUserHasActiveStripeSubscription({
  subscriptionTier,
  subscriptionSource
}: Pick<BaseSubscriptionInfo, 'subscriptionSource' | 'subscriptionTier'>) {
  if (subscriptionSource !== SubscriptionSource.StripeConsumer) {
    return false
  }
  if (subscriptionTier !== SubscriptionTier.premium && subscriptionTier !== SubscriptionTier.pro) {
    return false
  }
  return true
}

export function getSubscriptionSource({
  subscriptionTier,
  subscriptionSource
}: Pick<BaseSubscriptionInfo, 'subscriptionTier' | 'subscriptionSource'>): SubscriptionSource | null {
  if (subscriptionSource === SubscriptionSource.StripeOrganization) {
    return SubscriptionSource.StripeOrganization
  } else if (
    subscriptionTier === SubscriptionTier.pro ||
    subscriptionTier === SubscriptionTier.premium ||
    subscriptionTier === SubscriptionTier.light
  ) {
    if (subscriptionSource === SubscriptionSource.AppStoreConsumer) {
      return SubscriptionSource.AppStoreConsumer
    } else if (subscriptionSource === SubscriptionSource.CustomOverride) {
      return SubscriptionSource.CustomOverride
    } else if (subscriptionSource === SubscriptionSource.StripeConsumer) {
      return SubscriptionSource.StripeConsumer
    }
  }

  return null
}

/**
 * The subscription tier the web pages are told the user holds. A recurring plan (Lite, Plus, Pro,
 * Business, Business Pro) is passed through so /subscribe can mark it as the current plan and offer
 * to manage it; any other tier is presented as Starter.
 */
export function toPresentedSubscriptionTier(tier: UserTier): SubscriptionTier {
  switch (tier) {
    case SubscriptionTier.business_pro:
    case SubscriptionTier.business:
    case SubscriptionTier.pro:
    case SubscriptionTier.premium:
    case SubscriptionTier.light:
      return tier
    default:
      return SubscriptionTier.starter
  }
}
